/**
 * Label photos stay under Netlify's function limits (about 26 seconds and 6MB).
 * The long edge is 2000px. JPEG quality stays high, with 4:4:4 chroma and no
 * mozjpeg, so serial digits stay readable.
 * Keep an image that already fits. Resize once, at high quality, when it does not.
 */

const ASSISTANT_IMAGE_MAX_EDGE = 2000;
const ASSISTANT_JPEG_QUALITY = 0.92;
const ASSISTANT_JPEG_QUALITY_SHARP = 92;
const ASSISTANT_IMAGE_MAX_BYTES = Math.floor(4.5 * 1024 * 1024);
const LABEL_VISION_MODEL = 'claude-sonnet-5-5';

function mediaTypeFor(format) {
  const name = String(format || '').toLowerCase();
  if (name === 'png') return 'image/png';
  if (name === 'webp') return 'image/webp';
  if (name === 'gif') return 'image/gif';
  if (name === 'jpeg' || name === 'jpg') return 'image/jpeg';
  return '';
}

function planAssistantImage(info) {
  const source = info || {};
  const width = Math.round(Number(source.width) || 0);
  const height = Math.round(Number(source.height) || 0);
  const bytes = Math.round(Number(source.bytes) || 0);
  const longEdge = Math.max(width, height);
  const mediaType = mediaTypeFor(source.format);
  const oriented = Number(source.orientation) > 1;
  const fits = Boolean(mediaType)
    && !oriented
    && longEdge > 0
    && longEdge <= ASSISTANT_IMAGE_MAX_EDGE
    && bytes > 0
    && bytes <= ASSISTANT_IMAGE_MAX_BYTES;
  if (fits) {
    return { action: 'keep', mediaType, maxEdge: ASSISTANT_IMAGE_MAX_EDGE };
  }
  return {
    action: 'resize',
    mediaType: 'image/jpeg',
    maxEdge: ASSISTANT_IMAGE_MAX_EDGE,
    quality: ASSISTANT_JPEG_QUALITY_SHARP,
    mozjpeg: false,
    chromaSubsampling: '4:4:4',
  };
}

module.exports = {
  ASSISTANT_IMAGE_MAX_EDGE,
  ASSISTANT_JPEG_QUALITY,
  ASSISTANT_JPEG_QUALITY_SHARP,
  ASSISTANT_IMAGE_MAX_BYTES,
  LABEL_VISION_MODEL,
  planAssistantImage,
};
